import './styles.scss'
import { t } from 'i18next'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import microSignalsUtils from '../../utils/microSignals.utils'

const HistoryTerminalDataModal = ({ historyDataList, historyModalTitle, isHistoryPopupOpen, setIsHistoryPopupOpen, formatNumber }) => {
  const { determineTextColor } = microSignalsUtils

  const handleClose = () => {
    setIsHistoryPopupOpen(false)
  }

  const dialogModalContent = () => (
    <div className="history-macro-signals-data-table-wrapper">
      <table className="macro-signals-table">
        <thead>
          <tr>
            <th>{t('DATE')}</th>
            <th>{t('VOLUME')}</th>
            <th>{t('DIFFERENCE')}</th>
            <th>{t('OPEN_INTEREST')}</th>
            <th>{t('DIFFERENCE')}</th>
          </tr>
        </thead>

        <tbody>
          {historyDataList?.length === 0 ? (
            <tr>
              <td colSpan="5" className="table-loader">
                {t('LOADING_DATA')}
              </td>
            </tr>
          ) : (
            historyDataList.map((item, index) => (
              <tr key={index}>
                <td className="macro-signals-date">{item?.date}</td>
                <td className={determineTextColor(item?.volumeDifference)}>{formatNumber(item?.totalVolume)}</td>
                <td className={determineTextColor(item?.volumeDifference)}>{formatNumber(item?.volumeDifference)}</td>
                <td className={determineTextColor(item?.openInterestDifference)}>{formatNumber(item?.totalOpenInterest)}</td>
                <td className={determineTextColor(item?.openInterestDifference)}>{formatNumber(item?.openInterestDifference)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )

  return <DialogUIModal size="lg" titlePosition="center" title={`${historyModalTitle === '1' ? t('ROBUSTA') : t('ARABICA')} ${t('HISTORY_DATA')}`} showModal={isHistoryPopupOpen} handleClose={handleClose} bodyContent={dialogModalContent} />
}

export default HistoryTerminalDataModal
